import { Scissors } from 'lucide-react';
import AdminUserManagement from './AdminUserManagement';

export default function AdminStylists() {
  return (
    <AdminUserManagement
      role="stylist"
      title="Stylists"
      subtitle="Manage beauty professionals"
      Icon={Scissors}
      emptyText="No stylists found"
    />
  );
}
